import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { G2SanitizedInputDirective } from '../XSSdirective';



@NgModule({
  declarations: [G2SanitizedInputDirective],
  imports: [
    CommonModule
  ],
  exports:[
    G2SanitizedInputDirective
  ]
})
export class CfmsSharedModule { }
